import { render, staticRenderFns } from "./productPdf.vue?vue&type=template&id=2014b779&scoped=true"
import script from "./productPdf.vue?vue&type=script&lang=js"
export * from "./productPdf.vue?vue&type=script&lang=js"
import style0 from "./productPdf.vue?vue&type=style&index=0&id=2014b779&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2014b779",
  null
  
)

export default component.exports